<template>
    <div :class="$style.right">
        <div :class="[$style.right_wrapper, nativeBannersEnabled && $style.static]">
            <AdContainer
                placement="sidebar"
                :backgroundClass="$style.ad"
            />
            <AdContainer placement="sidebar_bottom" />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia'

import AdContainer from '@/components/AdContainer/AdContainer.vue'
import { useAdsStore } from '@/store/ads-store'

const { nativeBannersEnabled } = storeToRefs(useAdsStore())
</script>
<style module>
.right {
    width: var(--global-right-pannel-width);
    display: block;
    position: relative;
}
.ad {
    background-color: var(--experimental-purple-graphit);
    border-radius: var(--radius-12);
}
.right_wrapper {
    position: sticky;
    top: var(--pg-safe-area-top);
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.right_wrapper.static {
    position: static;
}
</style>
